<template>
  <div class="buy-map-controls-wrapper">
    <div class="buy-map-controls-header">MATCHING FILTERS</div>
<!-- 
    <label v-if="showCountry" for="country" class="control-label">Country</label>
    <select v-if="showCountry" v-model="countryCode" value="country" class="map-controls map-select" @change="changeCountry($event)">
      <option
        v-for="country in countries"
        :value="country.countryCode"
        v-bind:key="country.countryCode" 
      >{{ country.countryName }}</option>
    </select>

    <label for="tso_zone" class="control-label">TSO</label>
    <select value="tso_zone" class="map-controls map-select">
      <option
        v-for="tso in tsos"
        :value="tso.tsoCode"
        v-bind:key="tso.tsoCode"
        :selected="tso.tsoCode === 'ROTSO01'? true : false"
      >{{ tso.abbrName }}</option>
    </select>
 -->
    <label for="dso_zone" class="control-label">DSO</label>
    <select value="dso_zone" class="map-controls map-select" @change="changeDSOZone($event)">
      <option selected="true" value="dso-zone">All DSO Zones</option>
      <option
        v-for="dso_zone in dso_zones"
        :value="dso_zone.zoneCode"
        v-bind:key="dso_zone.zoneCode"
      >{{ dso_zone.zoneName }}</option>
    </select>

    <label for="region" class="control-label">Region</label>
    <select
      v-model="offer.locationCode"
      value="region"
      class="map-controls map-select"
      @change="changeState($event)"
    >
      <option selected="true" value="region">All Regions</option>
      <option
        v-for="location in locations"
        :value="location.locationCode"
        v-bind:key="location.locationCode"
      >{{ location.locationName }}</option>
    </select>

    <label for="date-from" class="control-label">Date From</label>
    <input
      type="date"
      v-model="offer.dateFrom"
      id="date-from"
      name="date-from"
      class="map-controls map-date"
    />

    <label for="date-to" class="control-label">Date To</label>
    <input
      type="date"
      v-model="offer.dateTo"
      id="date-to"
      name="date-to"
      class="map-controls map-date"
    />

    <label for="time-start" class="control-label">Time From</label>
    <input
      type="time"
      v-model="offer.timeFrom"
      id="time-start"
      name="date-from"
      class="map-controls map-time"
    />

    <label for="time-to" class="control-label">Time To</label>
    <input
      type="time"
      v-model="offer.timeTo"
      id="time-to"
      name="time-to"
      class="map-controls map-time"
    />

    <label for="when" class="control-label">Type of Day</label>
    <select value="when" v-model="offer.dayType" class="map-controls map-select">
      <option selected="true" value="when" disabled>Select Type of Day</option>
      <option value="weekdays">Week Days</option>
      <option value="weekends">Weekends</option>
      <option value="alldays">All Days</option>
    </select>
    <label for="volume" class="control-label">Volume (KWh)</label>
    <input
      type="number"
      v-model="offer.volume"
      id="volume"
      placeholder="Enter Max Volume"
      min="0"
      class="map-controls map-number"
    />
    <label for="price" class="control-label">Price (&#8364;/KWh)</label>
    <input
      type="number"
      v-model="offer.price"
      id="price"
      pattern="^\d*(\.\d{0,2})?$"
      placeholder="Enter Max Price"
      min="0"
      class="map-controls map-number"
    />

    <button class="eflex-button filter-button" v-on:click="filterOffers">Search</button>

    <div class="form-flex">
      <div class="results-header-container">
        <div class="control-label">Result offers:</div>
      </div>
    </div>
    <table class="results-table">
      <tbody :key="componentKey">
        <tr>
          <td>Location</td>
          <td>Volume</td>
        </tr>
        <tr v-for="offer in offers" v-bind:key="offer.offerCode">
          <td>{{ offer.locationCode }}</td>
          <td>{{ offer.volume }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import CountryDataService from "../../services/CountryDataService";
import TsoDataService from "../../services/TsoDataService";
import ZoneDataService from "../../services/ZoneDataService";
import LocationDataService from "../../services/LocationDataService";
import OfferDataService from "../../services/OfferDataService";

// const country = require("../../maps/bulgaria.json");
// const tso = require("../../maps/data/tso.json");

export default {
  data() {
    return {
      //selected: null,
      countryCode: this.$store.state.auth.user.countryCode,
      countries: [],
      cities: [],
      postcodes: [],
      assetcountries: [],
      tsos: [],
      assets: [],
      dso_zones: [],
      locations: [],
      dso_zone: null,
      location: null,
      offers: [],
      currentOfferIndex: -1,
      componentKey: 0,
      offer: {
        id: null,
        companyCode: "",
        offerCode: "",
        locationCode: "",
        dayType: "",
        dateFrom: "",
        dateTo: "",
        timeFrom: "",
        timeTo: "",
        volume: 0,
        price: 0,
      },
    };
    //submitted: false
  },

  props: ["map", "test", "country"],

  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    changeLayer(layer) {
      this.$emit("change", layer);
    },
    changeLoad(layer) {
      this.$emit("load", layer);
    },
    changeEV(layer) {
      this.$emit("ev", layer);
    },
    changeWind(layer) {
      this.$emit("wind", layer);
    },
    changeCountry(event) {
      this.$emit("country", event.target.value);
      console.log(event.target.value);
      this.retrieveTsos(event.target.value);
      this.retrieveZones(event.target.value);
      this.retrieveLocations(event.target.value);
    },
    changeDSOZone(event) {
      this.$emit("dso_zone", event.target.value);
      console.log(event.target.value);
      this.retrieveLocations(event.target.value);
    },
    changeState(event) {
      this.$emit("state", event.target.value);
      console.log(event.target.value);
    },
    changeYear(event) {
      this.$emit("year", event.target.value);
      console.log(event.target.value);
    },

    retrieveCountries() {
      /* 
      CountryDataService.getAll()
        .then((response) => {
          this.countries = response.data;
          console.log("HERE... load countries sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... load countries error: " + e);
        });
       */
      console.log("HERE... currentUser's role: " + this.$store.state.auth.user.roles);
      console.log("HERE... currentUser's country: " + this.$store.state.auth.user.countryCode);
      if (this.$store.state.auth.user.roles == "ROLE_ADMIN") {
        CountryDataService.getAll()
        .then((response) => {
          this.countries = response.data;
          console.log("HERE... load countries sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... load countries error: " + e);
        });
      } else {
        CountryDataService.findByCountryCode(this.$store.state.auth.user.countryCode)
        .then((response) => {
          this.countries = response.data;
          console.log("HERE... load country sucessfull: " + this.countries.countryCode);
        })
        .catch((e) => {
          console.log("HERE... load country error: " + e);
        });
      }
    },

    retrieveTsos(countryCode) {
      TsoDataService.findByCountryCode(countryCode)
        .then((response) => {
          this.tsos = response.data;
          console.log("HERE... load TSO zones sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... load TSO zones error: " + e);
        });
    },

    retrieveZones(countryCode) {
      ZoneDataService.findByCountryCode(countryCode)
        .then((response) => {
          this.dso_zones = response.data;
          console.log("HERE... load DSO zones sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... load DSO zones error: " + e);
        });
    },

    retrieveLocations(zoneCode) {
      LocationDataService.findByCountryCode(zoneCode)
        .then((response) => {
          this.locations = response.data;
          console.log("HERE... load locations sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... load locations zones error: " + e);
        });
    },

    filterOffers() {
      var data = {
        locationCode: this.offer.locationCode,
        dayType: this.offer.dayType,
        dateFrom: this.offer.dateFrom,
        dateTo: this.offer.dateTo,
        timeFrom: this.offer.timeFrom,
        timeTo: this.offer.timeTo,
        volume: this.offer.volume,
        price: this.offer.price,
      };
      console.log(
        "HERE... filter with parameters " +
          "/nlocationCode: " +
          data.locationCode +
          "dayType: " +
          data.dayType +
          "dateFrom: " +
          data.dateFrom +
          "dateTo: " +
          data.dateTo +
          "timeFrom: " +
          data.timeFrom +
          "timeTo: " +
          data.timeTo +
          "volume: " +
          data.volume +
          "price: " +
          data.price
      );
      OfferDataService.filters(data)
        .then((response) => {
          this.offers = response.data;
          console.log("HERE... load offers sucessfull: " + response.data);
        })
        .catch((e) => {
          console.log("HERE... load offers error: " + e);
        });
    },
  },

  computed: {

    currentUser() {
      return this.$store.state.auth.user;
    },

    showCountry() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_ADMIN");
      }

      return false;
    },
    /* getCountry() {
            return this.$props.country.features.sort((a, b) =>
                a.properties.name > b.properties.name ? 1 : -1
            );
        }, 

        getTSOZone() {
            return this.tso[this.country.countryName];
        },

        getDSOZone() {
            return country.DSOs.sort((a, b) =>
                a.name > b.name ? 1 : -1
            );
        },

        getProvince() {
            console.log(country.DSOs[0]);
            return country.DSOs[0].features.sort((a, b) =>
                a.properties.name > b.properties.name ? 1 : -1
            );
        } */
  },

  updated() {
    // Fired every second, should always be true
    // this.changeCountry(event);
    this.offers;
  },

  created() {
  },

  mounted: function () {
    this.$store.state.auth.user
    this.countryCode = this.$store.state.auth.user.countryCode;
    this.retrieveTsos(this.countryCode);
    this.retrieveZones(this.countryCode);
    this.retrieveLocations("BGDSO01");
    
    this.$nextTick(function () {
      
      this.retrieveCountries();
      //this.retrieveTsos("BG");
      //this.retrieveZones("BG");
      //  this.filterOffers();
      // Code that will run only after the entire view has been rendered
    });
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";
.buy-map-controls-wrapper {
  width: 270px;
  display: block;
  max-height: calc(100vh - 50px);
  overflow-x: auto;
  margin: 0;
  padding: 20px 20px 0 20px;
  background: $blue;
}
.buy-map-controls-header {
  font-size: 0.95em;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
}

.filter-button {
  margin-bottom: 40px;
}
</style>
